import React, { useState } from 'react';
import { UTMCondition } from '@scale/shared/onboardingControlPanel/types/edge';
import { UTMParameters } from '@scale/shared-types';
import { SelectMenu, MultiAutocomplete, Typography } from '@scale/scaleui';

interface UTMConditionValueInputProps {
  value: UTMCondition;
  onChange: (value: UTMCondition) => void;
  disabled?: boolean;
}

const UTMConditionValueInput: React.FC<UTMConditionValueInputProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const [utmCondition, setUTMCondition] = useState<UTMCondition>(value || {});

  return (
    <>
      <SelectMenu
        className="flex"
        options={Object.values(UTMParameters).map(field => ({
          id: field,
          name: field,
        }))}
        setSelected={e => {
          setUTMCondition({ ...utmCondition, values: [], field: e });
          onChange({ ...utmCondition, values: [], field: e });
        }}
        selectedOptionId={utmCondition.field}
        disabled={disabled}
      />
      <Typography.Paragraph1>has one of</Typography.Paragraph1>
      <MultiAutocomplete
        canCreateOption
        className="w-full"
        options={[]}
        values={utmCondition.values}
        setSelectedValues={values => {
          setUTMCondition({ ...utmCondition, values });
          onChange({ ...utmCondition, values });
        }}
      />
    </>
  );
};

export default UTMConditionValueInput;
